import React from 'react';
import AnnouncementBar, { Props as AnnouncementBarProps } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/announcement-bar';

interface Props {
  data: AnnouncementBarProps;
}

const AnnouncementBarTastic: React.FC<Props> = ({ data }) => {
  return <AnnouncementBar {...data} marketButtonDrawerClassName="w-[90%] max-w-380" />;
};

export default AnnouncementBarTastic;
